import component from './reject'

const com = {
  install (Vue) {
    Vue.component('reject', component)
  }
}
export default com
